import { styled } from 'buttered';
import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';

let Grid = styled('div')`
  display: grid;
  grid-template-columns: 220px 1fr;
  grid-template-rows: 1fr;
  gap: 10px;

  @media screen and (max-width: 650px) {
    display: block;
  }

  @media screen and (max-width: 950px) {
    gap: 0px;
  }
`;

let Bar = styled('div')`
  padding: 25px 0px;

  @media screen and (min-width: 650px) {
    height: fit-content;
    position: sticky;
    top: 150px;
  }

  @media screen and (max-width: 650px) {
    border-bottom: var(--vapor-border);
    padding: 25px;
  }
`;

let Main = styled('div')`
  padding: 25px;
`;

let Button = styled('button')`
  border: none;
  background: none;
  height: 40px;
  border-radius: 6px;
  padding: 0px 20px;
  display: flex;
  margin-bottom: 5px;
  width: 100%;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  & > div {
    display: flex;
  }

  svg {
    height: 16px;
    width: 16px;
  }

  span {
    height: 16px;
    line-height: 16px;
    margin-left: 10px;
    font-size: 12px;
  }

  &:hover,
  &:focus {
    color: var(--vapor-primary);
  }

  &.active {
    background: var(--vapor-accent-3);
  }

  &.upgrade {
    background: var(--vapor-primary);
    color: var(--vapor-primary-text);
  }
`;

export let Sidebar = ({
  children,
  active,
  items
}: {
  children: React.ReactNode;
  active: string;
  items: {
    id: string;
    href: string;
    name: React.ReactNode;
    icon: React.ReactElement;
    variant?: 'upgrade';
  }[];
}) => {
  return (
    <Grid>
      <Bar>
        <main>
          {items.map((item, index) => (
            <Link href={item.href} key={index}>
              <a>
                <Button className={clsx(item.variant, { active: active == item.id })}>
                  {item.icon}
                  <span>{item.name}</span>
                </Button>
              </a>
            </Link>
          ))}
        </main>
      </Bar>

      <Main>{children}</Main>
    </Grid>
  );
};
